import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-plus',
  imports: [],
  templateUrl: './plus.html',
  styleUrl: './plus.scss',
})
export class Plus {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
